import React from 'react';

import { classNames } from '@/helpers/classNames';

import styles from './ModalSectionSecondaryText.module.scss';

type ModalSectionSecondaryTextProps = {
	className?: string;
};

export const ModalSectionSecondaryText: React.FC<
	ModalSectionSecondaryTextProps
> = ({ className, children }) => {
	const classes = classNames([styles['root'], className]);

	return <div className={classes}>{children}</div>;
};
